﻿window.cBuilderEmailWidgetCtrlTelTel = function cBuilderEmailWidgetCtrlTelTel(option) {
    var Me = this;

    window.cBuilderEmailWidgetCtrlTel.call(this, option);

    this.nomWidget = "dxwidgetformteltel"
    this.icone = "fas fa-phone";
    this.typChamp = "tel";
    this.nomBt = "Téléphone fixe";
    this.titleBt = "Téléphone fixe<br/>Si l’internaute saisit autre chose qu’un numéro de téléphone fixe, un avertissement apparaîtra."
    this.labelCtrl = "Téléphone fixe"

};